import { createAsyncThunk } from '@reduxjs/toolkit'
import { Subscription } from '../../types/Subscription'
import { Extra } from '../../redux/store'

export const updateStep4EffectiveDate = createAsyncThunk<Subscription, string, Extra>(
  'subscription/updateStep4EffectiveDate',
  // Must pass the date as string to avoid serialization warning
  async (params: string, thunkApi) => thunkApi.extra.appApi.updateEffectiveDate(params)
)
